import React, { useContext, useState } from "react";
import { Button } from "reactstrap";
import style from "./Basket.module.scss";
import Numeric from "../Field/Numeric";
import { Field } from "../Field/Field";
import Account from "../Field/Account/Account";
import { UserType } from "../../../../utils/Helper";
import { Dispatch } from "../store/store";

const Edit = ({ ...props }) => {
  const { services } = useContext(Dispatch);
  const [errors, setErrors] = useState({});

  const onEdit = () => {
    const { account } = props;

    let newErrors = {};
    let fields = ["AccountName", "Quantity"];

    if (props.userType != UserType.Trader) {
      fields = [...fields, "HolderName", "Instruction"];
    }

    fields.forEach((name) => {
      if (account[name] == undefined || account[name] === "") {
        newErrors[name] = "Required field";
      }
    });

    if (
      !order ||
      !order.CurrentAccount ||
      (order.CurrentAccount.clientBankAccounts &&
        order.CurrentAccount.clientBankAccounts.some(
          (bankAccount) => bankAccount.currencyId == order.OrderCurrencyId,
        ) &&
        !order.CurrentAccount.selectedAccount &&
        !order.CurrentAccount.useCashAccount)
    ) {
      newErrors["clientBankAccounts"] = "Select a bank account";
    }

    if (account.Instruction == "Written") {
      const requiresAttachment = window.___APP_CONFIG___.requiresAttachment;
      if (!account.HasFile && !account.HasFileUploadPending && requiresAttachment) {
        newErrors["Instruction"] = "Require an attachment";
      } else if (props.parameters["MaxSubsWithWrittenInsBasket"] != null) {
        const totalAccountsWithFile = props.accounts
          ? props.accounts.reduce(
              (sum, item) =>
                item.AccountId != account.AccountId && item.Instruction == "Written" ? sum + 1 : sum,
              0,
            )
          : 0;

        if (totalAccountsWithFile + 1 > +props.parameters["MaxSubsWithWrittenInsBasket"]) {
          newErrors["Instruction"] = "Exceed maximum written accounts";
        }
      }
    }

    if (Object.keys(newErrors).length) {
      setErrors(newErrors);
    } else {
      props.onEdit(account);
      props.toggle();
    }
  };

  const {
    balanceReady,
    accountProps,
    toggle,
    readonly,
    isReadOnly,
    dispatch,
    order,
    hiddens,
    onChange,
    account,
    orderPdf,
  } = props;

  const isExistingAccount = order.Accounts
    ? order.Accounts.find((acc) => acc.index === account.index)
    : false;

  return (
    <div className={style.edit}>
      {/* ##### Account ###### */}
      <Account
        userType={props.userType}
        account={account}
        order={order}
        onChange={(fields) => onChange(fields)}
        balanceReady={balanceReady}
        attachmentDisabled={false}
        hasAttachment={account.HasFileUploadPending ? { uploadPending: true } : account.HasFile}
        dispatch={dispatch}
        readonly={readonly}
        errors={{
          AccountName: errors.AccountName,
          HolderName: errors.HolderName,
          Instruction: errors.Instruction,
          Quantity: errors.Quantity,
          clientBankAccounts: errors.clientBankAccounts,
        }}
        hiddens={hiddens}
        orderPdf={orderPdf}
        {...services.account}
        {...accountProps}
        setBasketErrors={setErrors}
      />
      <div className={style.actions}>
        <Button
          className={"btn-sm"}
          color="light"
          onClick={() => toggle(account.index, account && account.delete)}
        >
          {!isReadOnly ? "Cancel" : "Close"}
        </Button>{" "}
        {!isReadOnly && (
          <Button className={"primary btn-sm"} color="primary" onClick={() => onEdit()}>
            {isExistingAccount ? "Edit & Precheck" : "Add & Precheck"}
          </Button>
        )}
      </div>
    </div>
  );
};

export default Edit;
